import _ from 'lodash';
import dataModel from '../models/DataModel';

function findPageState(pageName) {
  const stateTree = dataModel.stateTree;
  const pageState = stateTree.page_states[pageName];
  return _.cloneDeep(pageState);
}

function setPageState(pageName, newPageState) {
  const pageStateValue = _.cloneDeep(newPageState);

  dataModel.store.dispatch({
    type: 'SET_PAGE_STATE',
    pageName,
    pageStateValue,
  });
}

function setPageStateEntry(pageName, entryKey, entryValue) {
  dataModel.store.dispatch({
    type: 'SET_PAGE_STATE_ENTRY',
    pageName,
    entryKey,
    entryValue,
  });
}

function clearState(clearOptions) {
  if (!clearOptions.ignorePageState || clearOptions.clearAll || clearOptions.newUser) {
    dataModel.store.dispatch({
      type: 'RESET_PAGE_STATES',
    });
  }
}

export default {
  findPageState,
  setPageState,
  setPageStateEntry,
  clearState,
};



// WEBPACK FOOTER //
// ./src/dao/PageStateDAO.js